import ProfileTopNavigation from "./ProfileTopNavigation";
import PrivacyPolicySection from "../../PageComponent/ProfilePage/PrivacyPolicySection";

function PrivacyPolicy() {

  return (
    <div className="text-coalBlack pb-[25%]">
      <ProfileTopNavigation pageTitle={"Privacy and Safety"} />
      <PrivacyPolicySection />
    </div>
  );
}

export default PrivacyPolicy;
